import { MapPin, Search } from "lucide-react"
import { useCallback, useRef, useState } from "react"
import { formatLocation } from "@/components/shared/formatLocation"
import { useAuthStore } from "@/features/auth/store/authStore"

interface IntentionSearchBarProps {
  onSearchChange: (query: string) => void
  className?: string
}

export function IntentionSearchBar({ onSearchChange, className = "" }: IntentionSearchBarProps) {
  const [searchQuery, setSearchQuery] = useState("")
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)
  const user = useAuthStore(state => state.user)
  const location = formatLocation(user?.city, user?.state)

  const handleSearchChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      const query = e.target.value
      setSearchQuery(query)

      if (debounceRef.current) clearTimeout(debounceRef.current)
      debounceRef.current = setTimeout(() => {
        onSearchChange(query)
      }, 300)
    },
    [onSearchChange],
  )

  return (
    <div className={`mt-3 pt-3 ${className}`}>
      <div className="flex items-center bg-connect-glass-bg border border-connect-glass-border rounded-[15px] h-[65px] px-[19px]">
        <Search className="w-[25px] h-[25px] text-text-primary opacity-90 flex-shrink-0" />
        <input
          type="text"
          placeholder="Search..."
          value={searchQuery}
          onChange={handleSearchChange}
          aria-label="Search rituals"
          className="flex-1 bg-transparent border-none outline-none text-[14px] font-semibold text-text-primary opacity-90 placeholder:text-text-primary placeholder:opacity-90 placeholder:font-normal px-3"
        />
        {location && (
          <div className="hidden md:flex items-center gap-1.5 flex-shrink-0">
            <MapPin className="w-[25px] h-[25px] text-text-primary opacity-90" />
            <span className="text-[14px] font-semibold text-text-primary opacity-90">
              {location}
            </span>
          </div>
        )}
      </div>
    </div>
  )
}
